import { render } from "./MisMedicos.vue?vue&type=template&id=3bd095e9&scoped=true&ts=true"
import script from "./MisMedicos.vue?vue&type=script&lang=ts"
export * from "./MisMedicos.vue?vue&type=script&lang=ts"

import "./MisMedicos.vue?vue&type=style&index=0&id=3bd095e9&lang=scss&scoped=true"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd095e9"]])

export default __exports__